<template>
    <transition :name="addedInPlaylist ? 'fade' : ''">
        <div class="item-wrapper" :style="{ 'background-color': '#FFFFFF' }" :class="{'paused': playlist.paused, 'first-item': firstItem}">
            <img v-if="!playlist.auto && canControl" class="handle" src="data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%206%2016%22%3E%0A%20%20%3Cpath%20opacity%3D%22.4%22%20d%3D%22M1.5%203h-1C.2%203%200%202.8%200%202.5v-1c0-.3.2-.5.5-.5h1c.3%200%20.5.2.5.5v1c0%20.3-.2.5-.5.5zM1.5%207h-1C.2%207%200%206.8%200%206.5v-1c0-.3.2-.5.5-.5h1c.3%200%20.5.2.5.5v1c0%20.3-.2.5-.5.5zM1.5%2011h-1c-.3%200-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h1c.3%200%20.5.2.5.5v1c0%20.3-.2.5-.5.5zM1.5%2015h-1c-.3%200-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h1c.3%200%20.5.2.5.5v1c0%20.3-.2.5-.5.5zM5.5%203h-1c-.3%200-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h1c.3%200%20.5.2.5.5v1c0%20.3-.2.5-.5.5zM5.5%207h-1c-.3%200-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h1c.3%200%20.5.2.5.5v1c0%20.3-.2.5-.5.5zM5.5%2011h-1c-.3%200-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h1c.3%200%20.5.2.5.5v1c0%20.3-.2.5-.5.5zM5.5%2015h-1c-.3%200-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h1c.3%200%20.5.2.5.5v1c0%20.3-.2.5-.5.5z%22/%3E%0A%3C/svg%3E">
            <div v-else class="handle-placeholder"></div>

            <div class="item-content">
                <p class="product-name"><strong>{{ product.name }}</strong></p>
                <div class="d-flex">

                    <div class="item-details">
                        <div>
                            <p class="product-detail">{{ product.seller.name }}</p>
                            <p class="product-detail">
                                <span v-if="showPrice">
                                    <span class="red-font">{{ price }}</span> /
                                </span>
                                {{ playlist.product_preference.size }}. &#215; <strong class="red-font">{{ playlist.order_quantity }}</strong>
                            </p>
                            <p class="product-detail">{{ grind }}</p>
                            <p>{{ lastDate() }}</p>
                        </div>
                        <p v-if="showScheduledDate()" class="product-detail red-font">
                            <i>Scheduled for {{ formatDateWithoutYear(getEstimatedOrderDate(playlist, order)) }}</i>
                        </p>
                    </div>

                    <div class="middle-container">
                        <a :href="productUrl">
                            <img v-bind:src="getFlavourImageUrl(product)" class="product-image" alt="Product" />
                        </a>

                        <div class="request-wrapper">
                            <div class="request" v-if="product.num_requests != null">
                                {{ product.num_requests[0] || 0 }}
                            </div>
                            <i class="fas fa-user request-icon"></i>
                        </div>
                    </div>

                    <div v-if="canControl && (addedInPlaylist || playlist.auto)" class="side-btn-wrapper">
                        <div class="fast-track-icon" @click="$emit('fast-track')">
                            <img v-if="firstItem && playlist.force_process_next_batch" src='~workplace/fast-track-icon-fill.svg' alt="Fast track on">
                            <img v-else src='~workplace/fast-track-icon.svg' alt="Fast track">
                        </div>
                        <img v-if="addedInPlaylist && !playlist.auto" src='~workplace/trash-icon.svg' class="trash-icon" alt="Trash" @click="removeItem()">
                    </div>
                    <div v-else class="side-btn-wrapper">
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import PlaylistMixin from '../../mixins/playlist-mixin'
    import CoffeeMixin from '../../mixins/coffee-mixin'
    import DateMixin from '../../mixins/date-mixin'
    import CommonMixin from '../../mixins/common-mixin'
    // Images
    import 'workplace/fast-track-icon.svg';
    import 'workplace/fast-track-icon-fill.svg';
    import 'workplace/trash-icon.svg';

    export default {
        props: {
            playlist: Object,
            product: Object,
            bgColor: String,
            addedInPlaylist: Boolean,
            firstItem: Boolean,
            isPlaylistEmpty: Boolean,
            showPrice: Boolean,
            canControl: Boolean,
            order: Number,
            taxRate: Number
        },
        data: function() {
            return  {
                originalBgColor: this.bgColor
            }
        },
        computed: {
            price: function () {
                let size = this.playlist.product_preference.size
                let productPrice = this.product.product_custom_sizes.filter(r=> r.custom_size.imperial_uom === size)[0].final_price_cents
                const taxedPrice = this.calcTaxedPriceCents(productPrice, this.taxRate);
                return this.formatPrice(taxedPrice);
            },
            grind: function () {
                return this.humanizeGrind(this.playlist.product_preference.grind);
            },
            productUrl: function () {
                return `/workplace/coffees/${this.product.id}`
            },
            displaySize: function() {
               this.playlist.product_preference.size
            }
        },
        methods: {
            removeItem() {
                this.$api.delete('remove_product', {params: { playlistId: this.playlist.id, productId: this.product.id }})
                    .then(() => { this.$emit('remove', this.product.id) })
                    .catch()
            },
            lastDate(){
                var dateString = this.product.num_requests != null ? this.product.num_requests[1] : undefined;
                if (dateString !== undefined) {
				    let date = new Date(dateString);
				    const options = { year: 'numeric', month: 'short', day: 'numeric' };
				    dateString = date.toLocaleDateString("en-US", options);
				    return 'Last Request ' + dateString;
			    } else {
				    return '';
			    }
            },
            showScheduledDate() {
                if (this.addedInPlaylist || this.playlist.auto || this.isPlaylistEmpty) {
                    if (this.playlist.paused) {
                        // Don't show the date if the playlist is paused for indefinitely.
                        return !!this.playlist.resume_at;
                    }
                    return true;
                }
                return false;
            }
        },
        mixins: [
            PlaylistMixin,
            CoffeeMixin,
            DateMixin,
            CommonMixin
        ]
    }

</script>

<style scoped lang="scss">
    @import "../../styles/_variables_workplace.scss";

    .item-wrapper {
        display: flex;
        border-bottom: 1px solid $blue-light;
    }

    .first-item {
        border-top: 1px solid $blue-light;
    }

    .item-content {
        min-height: 100px;
        padding-right: 0.5rem;
    }

    .d-flex {
        display: flex;
    }

    .paused {
        opacity: 0.6;
    }

    .product-name {
        padding-top: 8px;
    }

    .handle {
        width: 8px;
        padding: 14px;
        cursor: pointer;
    }

    .handle-placeholder {
        width: 8px;
        padding: 14px;
    }

    .handle:hover {
        color: #333;
    }

    .item-details {
        width: 164px;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
    }

    .product-detail {
        font-size: 16px;
        margin-bottom: 2px;
    }

    .product-image {
        width: 64px;
        height: 64px;
    }

    .middle-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
    }

    .request-icon {
        position: relative;
        left: 26px;
    }

    .request-wrapper {
        width: 40px;
        margin-left: 5px;
    }

    .request {
        width: 30px;
        height: 18px;
        background: #1F323B;
        position: relative;
        -moz-border-radius: 40px;
        -webkit-border-radius: 40px;
        border-radius: 40px;
        color: white;
        text-align: center;
        font-size: 12px;
    }
    .request:before {
        content: "";
        position: absolute;
        left: 4px;
        top: 16px;
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid #1F323B;
        border-bottom: 6px solid transparent;
    }

    .side-btn-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
        margin-left: 8px;
        min-width: 36px;
    }

    .fast-track-icon {
        width: 36px;
        height: 36px;
        cursor: pointer;
    }

    .trash-icon {
        width: 28px;
        height: 28px;
        cursor: pointer;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .7s ease;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        .handle {
            height: 100%;
            padding: 50px 8px;
        }
    }
</style>
